/**
 * aggregation.module.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { ModuleWithProviders, NgModule, Provider } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "../shared/shared.module";

// OWN SERVICES

import { AggregationService } from "./aggregation.service";

// OWN COMPONENTS

import { AggregationTaskComponent }
	from "./aggregation-task.component";
import { AggregationComponent } from "./aggregation.component";
import { AggregatorListComponent }
	from "./aggregator-list.component";
import { ColumnSelectionInputComponent }
	from "./column-selection-input.component";
import { DataExportTaskComponent } from "./export-task.component";
import { FilterNodeComponent } from "./filter-node.component";
import { SimpleFilterNodeComponent } from "./simple-filter-node.component";
import { TaskProgressComponent } from "./task-progress.component";


import { AdvancedColumnSelectionModalComponent }
	from "../aggregation/advanced-column-selection-modal.component"

// MISC

const AGGREGATION_ROUTING : ModuleWithProviders =
	RouterModule.forChild([{path: "", component: AggregationComponent}]);

@NgModule({
	imports: [ SharedModule, AGGREGATION_ROUTING ],
	declarations: [
		AdvancedColumnSelectionModalComponent,
		AggregationComponent,
		AggregatorListComponent,
		AggregationTaskComponent,
		ColumnSelectionInputComponent,
		DataExportTaskComponent,
		FilterNodeComponent,
		SimpleFilterNodeComponent,
		TaskProgressComponent
	],
	entryComponents: [
		AdvancedColumnSelectionModalComponent
	],
	exports: [],
	providers: []
 })
export class AggregationModule {
	public static forRoot () : ModuleWithProviders
	{
		return {
			ngModule: AggregationModule,
			providers: [AggregationService]
		};
	}
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/aggregation/aggregation.module.ts